import { getLegacyDateCalendarCustomizing } from "@ui5/webcomponents-base/dist/config/FormatSettings.js";

const emptyFn = () => {};

/**
 * OpenUI5 Formatting Shim
 */
const Formatting = {
	getABAPDateFormat: emptyFn,
	getCustomIslamicCalendarData: getLegacyDateCalendarCustomizing,
};

export default Formatting;
